import React, { useState } from 'react';

interface ImageGridProps {
  images: string[];
  title: string;
  maxPreview?: number;
  onImageSelect?: (imageData: {
    imageUrl: string;
    title: string;
    images: { url: string; title?: string }[];
    currentIndex: number;
  }) => void;
}

const ImageGrid: React.FC<ImageGridProps> = ({
  images,
  title,
  maxPreview = 12,
  onImageSelect,
}) => {
  const [showAll, setShowAll] = useState(false);

  if (images.length === 0) return null;

  const displayImages = showAll ? images : images.slice(0, maxPreview);
  const hasMore = images.length > maxPreview;

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-3">
        <h5 className="text-sm font-medium text-gray-800">
          {title} ({images.length})
        </h5>
        {hasMore && (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-xs text-blue-600 hover:text-blue-800 font-medium"
          >
            {showAll ? 'Thu gọn' : `Xem thêm ${images.length - maxPreview} ảnh`}
          </button>
        )}
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {displayImages.map((imageUrl, index) => (
          <div
            key={index}
            className="relative group cursor-pointer overflow-hidden rounded-lg border border-gray-200 hover:border-blue-300 transition-all duration-200 hover:shadow-md"
            onClick={() =>
              onImageSelect?.({
                imageUrl,
                title,
                images: images.map((url) => ({ url })),
                currentIndex: index,
              })
            }
          >
            <div className="aspect-square bg-gray-100">
              <img
                src={imageUrl}
                alt={`${title} ${index + 1}`}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.parentElement!.innerHTML = `
                    <div class="w-full h-full flex items-center justify-center bg-gray-100">
                      <svg class="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                      </svg>
                    </div>
                  `;
                }}
              />
            </div>
            <div className="absolute inset-0 bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-200 flex items-center justify-center">
              <svg
                className="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                ></path>
              </svg>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageGrid;
